export default __webpack_public_path__ + "static/media/angular.b976c289.png";